// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"c6053c80","453":"8aa89ac1"}[chunkId] + ".chunk.js";
};